export default __webpack_public_path__ + "src/assets/gridplus-large.55073358e5410a8eb5f351e851a3d576.svg";